import React, { useEffect } from "react";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCol,
  IonContent,
  IonFab,
  IonGrid,
  IonHeader,
  IonIcon,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { UsersListContainer } from "./components/UsersListContainer";
import { useDispatch } from "react-redux";
import findUsers from "../../store/users/actions/findUsers";
import { UsersSearchBar } from "./components/UsersSearchBar";
import { addOutline } from "ionicons/icons";
import { FilterSection } from "../DocumentList/components/FilterSection";
import { SortSelector } from "../DocumentList/components/SortSelector";
import { ViewModeSelector } from "../DocumentList/components/ViewModeSelector";

export const UsersList: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(findUsers());
  }, [dispatch]);
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/rrhh"></IonBackButton>
          </IonButtons>
          <IonTitle>Usuarios</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Usuarios</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonButton routerLink="/app/rrhh/usuarios/nuevo" size="large" color="secondary">
            <IonIcon icon={addOutline} slot="start"></IonIcon>
            <IonText>Crear usuario</IonText>
          </IonButton>
        </IonFab>

        <section className="ion-padding">
          <IonGrid>
            <IonRow>
              <IonCol size="12" sizeMd="8" sizeLg="6">
                <UsersSearchBar />
              </IonCol>
            </IonRow>
          </IonGrid>
{/* 
          <IonGrid>
            <IonRow class="ion-align-items-center">
              <IonCol>
                <FilterSection />
              </IonCol>
              <IonCol size="auto" style={{ display: "flex" }}>
                <SortSelector />
                <ViewModeSelector />
              </IonCol>
            </IonRow>
          </IonGrid> */}

          <UsersListContainer />
        </section>
      </IonContent>
    </IonPage>
  );
};
